import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useMobileFontOverrides} from '../../../../../commons/hooks/use-mobile-font-overrides'
import {FormStep} from '../../constants'
import c from '../classnames.scss'
import {FormButton} from '../form-button'
import {FormSteps, Step} from '../form-steps'
import {RegistrationLayout} from '../registration-layout'
import {Summary} from '../summary'
import {Summary as SummaryOld} from '../summary/old'
import {RsvpFormContainer} from './container'
import {RsvpFormProps} from './interfaces'
import s from './rsvp-form.scss'

export const RsvpForm = ({
  closedRegistrationMessage,
  registrationClosed,
  memberRsvpReady,
  memberRsvpExists,
  ticketedEvent,
  shouldNavigateToForm,
  navigateToMainPage,
  formPageLoaded,
  scrollToElement,
}: RsvpFormProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const updatedCheckoutSummaryEnabled = experiments.enabled(ExperimentNames.UpdatedCheckoutSummary)
  const {mobileFontOverridesEnabled} = useMobileFontOverrides()

  React.useEffect(() => {
    formPageLoaded()
  }, [])

  if (!memberRsvpReady || (memberRsvpExists && !ticketedEvent && !shouldNavigateToForm)) {
    return null
  }

  const containerClass = classNames(c.formBackgroundColor)

  if (registrationClosed) {
    return (
      <div className={classNames(containerClass, s.closedRegistrationMessageContainer)}>
        <div
          className={classNames(s.closedRegistrationMessage, c.formTitleFont, c.formTitleColor, {
            [s.mobileFontSize]: mobileFontOverridesEnabled,
          })}
        >
          {closedRegistrationMessage.message}
        </div>
        <FormButton
          text={closedRegistrationMessage.exploreEventsActionLabel}
          width="auto"
          onClick={() => navigateToMainPage()}
        />
      </div>
    )
  }

  return (
    <RsvpFormContainer>
      {(steps: Step[], currentStep: FormStep) => (
        <div className={containerClass}>
          <RegistrationLayout
            Right={updatedCheckoutSummaryEnabled ? <Summary /> : <SummaryOld />}
            Left={<FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />}
          />
        </div>
      )}
    </RsvpFormContainer>
  )
}
